import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api/axios';

function Webinarsuccess() {
  const { idtransaction, nilai } = useParams();
  const [phone, setPhone] = useState('');
  const member = JSON.parse(localStorage.getItem('member_user') || 'null');

  useEffect(() => {
    api.get(`/api/webinar-payment-by-transaction/${idtransaction}`)
      .then(res => {
        if (res.data?.number) setPhone(res.data.number);
      })
      .catch(() => {});
  }, [idtransaction]);

  const isGuest = !member;

  return (
    <div className="container mt-5 text-center">
      <h2 className="text-success mb-4">Pembayaran Berhasil 🎉</h2>
      {/* ss layar ini */}
      <p className="mb-4">Terima kasih telah melakukan pembayaran. SS layar ini kemudian kirim ke 087776572240.</p>

      {isGuest && (
        <div className="card shadow-sm mx-auto mb-4" style={{ maxWidth: '450px', borderColor: '#F68D6E' }}>
          <div className="card-body">
            <h5 className="card-title">🔑 Akun Anda Telah Dibuat</h5>
            <p className="card-text text-muted">
              Akun peserta untuk kelas ini telah dibuat secara otomatis.
            </p>
            <div className="alert alert-warning mb-3" style={{ textAlign: 'left' }}>
              <p className="mb-1"><strong>Nomor HP:</strong> {phone || '-'}</p>
              <p className="mb-0"><strong>Password sementara:</strong> 123456</p>
            </div>
            <p className="card-text small text-muted mb-3">
              ⚠️ Setelah login, segera ganti password di menu <strong>Pengaturan Profil</strong>.
            </p>
            <Link to="/login" className="btn btn-dark w-100">
              Login Sekarang
            </Link>
          </div>
        </div>
      )}

      <div className="card shadow-sm mx-auto" style={{ maxWidth: '400px' }}>
        <div className="card-body">
          <h5 className="card-title">Detail Pembayaran</h5>
          <p className="card-text">
            <strong>ID Transaksi:</strong> {idtransaction}
          </p>
          <p className="card-text">
            <strong>Total Pembayaran:</strong> Rp {parseInt(nilai).toLocaleString('id-ID')}
          </p>
          <Link to={member ? '/my-classes' : '/'} className="btn btn-primary mt-3">
            {member ? 'Ke Kelas Saya' : 'Kembali ke Beranda'}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Webinarsuccess;
